module.exports = __webpack_public_path__ + "img/contents-2@3x.0d6c229d.png";